const Joi = require("joi");

const loginSchema = (data) => {
  const schema = Joi.object({
    // UserName: Joi.string()
    //   .trim()
    //   .required()
    //   .messages({
    //     "string.pattern.base": "Invalid LoginId",
    //     "any.required": "The LoginId field is required.",
    //   }),
    UserName: Joi.string()
      .trim()
      .required()
      .messages({
       // 'string.base': 'User Name must be a string.',
       // 'string.alphanum': 'User Name must only contain alphanumeric characters.',
       // 'string.min': 'User Name must be at least {#limit} characters long.',
       // 'string.max': 'User Name must be at most {#limit} characters long.',
       // 'any.required': 'Please enter Username / E-mail.',
        "any.required": "Please enter Username / E-mail.",
        "string.empty": "Please enter Username / E-mail.",
      }),
    // LoginId: Joi.string()
    //   .trim()
    //   .email({ minDomainSegments: 2, tlds: { allow: ["com", "net", "org"] } })
    //   .required()
    //   .messages({
    //     "string.email": "Please provide a valid email address.",
    //     "any.required": "The Email field is required.",
    //   }),

    UserPassword: Joi.string()
 //   .pattern(new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,}$'))
    .required()
    .messages({
      'string.pattern.base': 'Password must be at least 8 characters long and include at least one uppercase letter, one lowercase letter, and one special character.',
      "any.required": "Please enter password.",
      "string.empty": "Please enter password.",
    }),
  }).unknown(true);
  
  return schema.validate(data, { abortEarly: false });
};


module.exports = loginSchema;
